import React from "react";
import { Paper } from "@material-ui/core";
import RoleSection from "../../../components/layouts/RoleSection";
import {
  activityRoles,
  companyRoles,
  contactsRoles,
  customFieldsRoles,
  dashboardRoles,
  diagnosisRoles,
  documentsRoles,
  driverRoles,
  fleetboxRoles,
  fleetPageRoles,
  fleetRoles,
  incidentsRoles,
  invoiceRoles,
  iotKeylessAccessRoles,
  keylessAccessMode,
  logBookRoles,
  lsvaRoles,
  overviewRoles,
  privateMode,
  rentalRoles,
  reportingRoles,
  reservationRoles,
  resourcePlannerRoles,
  searchRoles,
  smsRoles,
  bridgeRoles,
  tachoRoles,
  tagsRoles,
  tracesRoles,
  uiRoles,
  userRoles,
  vehiclesRoles,
  vehicleTypesRoles,
  zonesRoles,
} from "../../../utils/roles";
import { useStyles } from "./styles";

interface Props {
  handleToggle: (value: any) => void;
  permissions: any;
}

const Permissions: React.FC<Props> = ({ handleToggle, permissions }: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <RoleSection
          title="UI"
          roles={uiRoles(
            permissions?.viewPortalFrontend,
            permissions?.sendFeedback,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Vehicle Viewing"
          roles={vehiclesRoles(
            permissions?.getVehicles,
            permissions?.getVehicleGroups,
            permissions?.viewHistory,
            permissions?.viewHistoryParams,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Private Mode"
          roles={privateMode(
            permissions?.showPrivateData,
            permissions?.setPrivateVehicles,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="IoT Keyless Access"
          roles={iotKeylessAccessRoles(
            permissions?.viewIoTKeylessAccess,
            permissions?.editIoTKeylessAccess,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Keyless Access"
          roles={keylessAccessMode(
            permissions?.keylessAccess,
            permissions?.keylessAccessAdmin,
            permissions?.giveKeylessAccess,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Fleet page"
          roles={fleetPageRoles(permissions?.viewFleetPage)}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Technical Status Page"
          roles={diagnosisRoles(permissions?.viewDiagnosis)}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Logbook"
          roles={logBookRoles(
            permissions?.viewLogs,
            permissions?.createLogs,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Overview page"
          roles={overviewRoles(permissions?.viewOverview)}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Activity status"
          roles={activityRoles(permissions?.viewActivity)}
          handleChange={handleToggle}
        />
        <RoleSection
          title="LSVA"
          roles={lsvaRoles(
            permissions?.viewLSVA,
            permissions?.manualCorrectLSVA,
            permissions?.revokeLSVA,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Driver"
          roles={driverRoles(
            permissions?.viewDriver,
            permissions?.createDriver,
            permissions?.editDriver,
            permissions?.deleteDriver,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Incidents"
          roles={incidentsRoles(
            permissions?.viewIncidents,
            permissions?.createIncidents,
            permissions?.editIncidents,
            permissions?.deleteIncidents,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Reservation"
          roles={reservationRoles(
            permissions?.viewReservation,
            permissions?.createReservation,
            permissions?.adminReservation,
            permissions?.edit_third_party_reservation,
            permissions?.unlimitedReservation,
            permissions?.shareReservation,
            permissions?.manageAttributesReport,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Zones"
          roles={zonesRoles(
            permissions?.viewZones,
            permissions?.createZones,
            permissions?.editZones,
            permissions?.deleteZones,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Documents"
          roles={documentsRoles(
            permissions?.viewDocuments,
            permissions?.manageDocuments,
            permissions?.deleteDocuments,
            permissions?.manageReservationDocuments,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Custom Fields"
          roles={customFieldsRoles(permissions?.customFieldsAdmin)}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Resource Planner"
          roles={resourcePlannerRoles(permissions?.viewResourcePlanner)}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Contacts"
          roles={contactsRoles(
            permissions?.viewContacts,
            permissions?.createContacts,
            permissions?.editContacts,
            permissions?.deleteContacts,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Reporting"
          roles={reportingRoles(
            permissions?.viewReports,
            permissions?.reportJobsAdmin,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Tacho"
          roles={tachoRoles(
            permissions?.viewTacho,
            permissions?.tachoDownload,
            permissions?.tachoScheduler,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Invoice"
          roles={invoiceRoles(
            permissions?.viewInvoice,
            permissions?.approveInvoice,
            permissions?.releaseInvoice,
            permissions?.viewReleaseInvoice,
            permissions?.releaseInvoiceDealer,
            permissions?.manageReleaseInvoice,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Traces"
          roles={tracesRoles(
            permissions.viewRadius,
            permissions?.viewTraces,
            permissions?.viewAccurateWidth,
            permissions?.editVehicleToFollow,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Dashboards"
          roles={dashboardRoles(
            permissions.viewDashboards,
            permissions?.viewEco,
            permissions?.viewDriverRanking,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Company"
          roles={companyRoles(
            permissions?.editCompany,
            permissions?.viewCompany,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Global Search"
          roles={searchRoles(permissions?.viewSearchByAttributes)}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Tags"
          roles={tagsRoles(
            permissions?.viewTags,
            permissions?.createTags,
            permissions?.editTags,
            permissions?.deleteTags,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Vehicle Types"
          roles={vehicleTypesRoles(
            permissions?.viewVehicleTypes,
            permissions?.createVehicleTypes,
            permissions?.editVehicleTypes,
            permissions?.deleteVehicleTypes,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Users"
          roles={userRoles(
            permissions?.createUsers,
            permissions?.editUsers,
            permissions?.deleteUsers,
            permissions?.editRoles,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Vehicle Management"
          roles={fleetRoles(
            permissions?.createVehicles,
            permissions?.editVehicles,
            permissions?.deleteVehicles,
            permissions?.editGroups,
            permissions?.editModels,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Fleetbox"
          roles={fleetboxRoles(
            permissions?.viewFleetboxModule,
            permissions?.createFleetbox,
            permissions?.editFleetbox,
            permissions?.deleteFleetbox,
            permissions?.firmwareAdmin,
          )}
          handleChange={handleToggle}
        />

        <RoleSection
          title="Rental"
          roles={rentalRoles(
            permissions?.rentalTariffsAdmin,
            permissions?.rentalViewInvoices,
            permissions?.rentalEditInvoices,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="SMS Commands"
          roles={smsRoles(
            permissions?.sendSMSCommands,
            permissions?.sendSMSCommandsAdmin,
          )}
          handleChange={handleToggle}
        />
        <RoleSection
          title="Bridge Commands"
          roles={bridgeRoles(
            permissions?.sendBridgeCommands,
          )}
          handleChange={handleToggle}
        />
      </Paper>
    </div>
  );
};

export default Permissions;
